import { Icon } from "./Icon";

export function Button({ disabled = false, type = "button", ...props }: React.ComponentProps<"button">) {
  const secondary = `group-[.secondary]:bg-white group-[.secondary]:text-black group-[.secondary]:border-2 group-[.secondary]:border-black`;
  const teritary = `group-[.teritary]:text-blue-550 group-[.teritary]:border-2 group-[.teritary]:border-blue-550 group-[.teritary]:bg-white`;
  const noBorder = `group-[.noBorder]:border-none`;
  const imgBtn = `group-[.imgbtn]:border group-[.imgbtn]:bg-transparent group-[.imgbtn]:text-white`;
  const danger = `group-[.danger]:bg-red-500 group-[.danger]:hover:bg-red-600 group-[.danger]:text-white`;

  return (
    <button
      {...props}
      disabled={disabled}
      className={`bg-blue-550 ${
        disabled ? "cursor-not-allowed opacity-50" : "hover:bg-blue-600"
      } text-white ${secondary} ${teritary} ${noBorder} ${imgBtn} ${danger} px-3 py-3 ${props.className}`}
      type={type}
    />
  );
}

export function ButtonWithIcon({
  icon,
  iconFirst,
  children,
  ...props
}: React.ComponentProps<typeof Button> & { icon: string | React.ReactNode; iconFirst?: boolean }) {
  return (
    <Button {...props}>
      <div className={"flex items-center justify-center gap-2 px-3 " + (!iconFirst ? "flex-row-reverse" : "")}>
        {typeof icon === "string" ? (
          <Icon
            svg={icon}
            color="filter-white group-[.secondary]:filter-black group-[.teritary]:filter-blue-550"
            className="h-5 w-5"
          />
        ) : (
          icon
        )}
        <span>{children}</span>
      </div>
    </Button>
  );
}
